import { byokFetch } from "./client";
import type { ByokKey, RegisterKeyInput } from "../types";

export async function registerByokKey(input: RegisterKeyInput): Promise<ByokKey> {
  return byokFetch<ByokKey>("byok-keys", "", {
    method: "POST",
    body: JSON.stringify(input),
  });
}
